/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ProductListsCollectionView_ProductListFragmentDoc } from '../../features/productLists/ProductListsCollectionView.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProductLists_ProductListAuthorFragment = { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string };

export type ProductLists_ProductListFragment = { __typename: 'ProductList', id: string, title: string, description: string, createdAt: any, itemCount: number, author: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string } };

export type ProductListsQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit: Types.Scalars['Int']['input'];
  searchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sorting?: Types.InputMaybe<Array<Types.ProductListsSorting>>;
  filters?: Types.InputMaybe<Types.ProductListsFilters>;
  withImages: Types.Scalars['Boolean']['input'];
}>;


export type ProductListsQuery = { productLists: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'ProductListConnection', totalCount: number, edges: Array<{ __typename: 'ProductListEdge', node: { __typename: 'ProductList', id: string, title: string, description: string, createdAt: any, itemCount: number, author: { __typename: 'User', id: string, fullname: string, firstname: string, familyname: string }, images?: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }> } }> } };

export type DeleteProductListMutationVariables = Types.Exact<{
  input: Types.DeleteProductListInput;
}>;


export type DeleteProductListMutation = { deleteProductList: { __typename: 'DeleteProductListResult', ok: boolean } };

export type DuplicateProductListMutationVariables = Types.Exact<{
  input: Types.DuplicateProductListInput;
}>;


export type DuplicateProductListMutation = { duplicateProductList: { __typename: 'DuplicateProductListResult', productList: { __typename: 'ProductList', id: string, title: string, description: string, createdAt: any, itemCount: number, author: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string } } } };

export const ProductLists_ProductListAuthorFragmentDoc = gql`
    fragment ProductLists_ProductListAuthor on User {
  id
  firstname
  familyname
  fullname
}
    `;
export const ProductLists_ProductListFragmentDoc = gql`
    fragment ProductLists_ProductList on ProductList {
  id
  title
  description
  createdAt
  itemCount
  author {
    ...ProductLists_ProductListAuthor
  }
}
    ${ProductLists_ProductListAuthorFragmentDoc}`;
export const ProductListsDocument = gql`
    query ProductLists($offset: Int, $limit: Int!, $searchTerm: String, $sorting: [ProductListsSorting!], $filters: ProductListsFilters, $withImages: Boolean!) {
  productLists(
    offset: $offset
    limit: $limit
    search: $searchTerm
    sorting: $sorting
    filters: $filters
  ) {
    ... on ProductListConnection {
      edges {
        node {
          ...ProductListsCollectionView_ProductList
        }
      }
      totalCount
    }
  }
}
    ${ProductListsCollectionView_ProductListFragmentDoc}`;

/**
 * __useProductListsQuery__
 *
 * To run a query within a React component, call `useProductListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      searchTerm: // value for 'searchTerm'
 *      sorting: // value for 'sorting'
 *      filters: // value for 'filters'
 *      withImages: // value for 'withImages'
 *   },
 * });
 */
export function useProductListsQuery(baseOptions: Apollo.QueryHookOptions<ProductListsQuery, ProductListsQueryVariables> & ({ variables: ProductListsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListsQuery, ProductListsQueryVariables>(ProductListsDocument, options);
      }
export function useProductListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListsQuery, ProductListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListsQuery, ProductListsQueryVariables>(ProductListsDocument, options);
        }
export function useProductListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListsQuery, ProductListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListsQuery, ProductListsQueryVariables>(ProductListsDocument, options);
        }
export type ProductListsQueryHookResult = ReturnType<typeof useProductListsQuery>;
export type ProductListsLazyQueryHookResult = ReturnType<typeof useProductListsLazyQuery>;
export type ProductListsSuspenseQueryHookResult = ReturnType<typeof useProductListsSuspenseQuery>;
export type ProductListsQueryResult = Apollo.QueryResult<ProductListsQuery, ProductListsQueryVariables>;
export const DeleteProductListDocument = gql`
    mutation DeleteProductList($input: DeleteProductListInput!) {
  deleteProductList(input: $input) {
    ok
  }
}
    `;
export type DeleteProductListMutationFn = Apollo.MutationFunction<DeleteProductListMutation, DeleteProductListMutationVariables>;

/**
 * __useDeleteProductListMutation__
 *
 * To run a mutation, you first call `useDeleteProductListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductListMutation, { data, loading, error }] = useDeleteProductListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductListMutation, DeleteProductListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductListMutation, DeleteProductListMutationVariables>(DeleteProductListDocument, options);
      }
export type DeleteProductListMutationHookResult = ReturnType<typeof useDeleteProductListMutation>;
export type DeleteProductListMutationResult = Apollo.MutationResult<DeleteProductListMutation>;
export type DeleteProductListMutationOptions = Apollo.BaseMutationOptions<DeleteProductListMutation, DeleteProductListMutationVariables>;
export const DuplicateProductListDocument = gql`
    mutation DuplicateProductList($input: DuplicateProductListInput!) {
  duplicateProductList(input: $input) {
    productList {
      ...ProductLists_ProductList
    }
  }
}
    ${ProductLists_ProductListFragmentDoc}`;
export type DuplicateProductListMutationFn = Apollo.MutationFunction<DuplicateProductListMutation, DuplicateProductListMutationVariables>;

/**
 * __useDuplicateProductListMutation__
 *
 * To run a mutation, you first call `useDuplicateProductListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateProductListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateProductListMutation, { data, loading, error }] = useDuplicateProductListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateProductListMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateProductListMutation, DuplicateProductListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateProductListMutation, DuplicateProductListMutationVariables>(DuplicateProductListDocument, options);
      }
export type DuplicateProductListMutationHookResult = ReturnType<typeof useDuplicateProductListMutation>;
export type DuplicateProductListMutationResult = Apollo.MutationResult<DuplicateProductListMutation>;
export type DuplicateProductListMutationOptions = Apollo.BaseMutationOptions<DuplicateProductListMutation, DuplicateProductListMutationVariables>;